package com.eladfinish.bible.contest.screens.search.usecases.facts

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.screens.search.model.SearchPlaceData
import com.eladfinish.bible.contest.screens.search.usecases.GetChapterVersesUseCase
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.SpecialSearch
import com.eladfinish.bible.contest.search_progress_special_search_format
import com.eladfinish.bible.contest.utils.addGershaim
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.format

class ExecuteSpecialSearchUseCase(
    private val getChapterVersesUseCase: GetChapterVersesUseCase,
    private val assetReader: AssetReader,
    private val mapSpecialSearchItemsToUiModelsUseCase: MapSpecialSearchItemsToUiModelsUseCase,
) {

    operator fun invoke(
        searchedChapters: List<SearchPlaceData>,
        searchType: SpecialSearch,
        shouldShowAsList: Boolean,
        shouldKeepRunning: () -> Boolean,
        onProgress: (book: String, chapter: String) -> Unit,
    ): SpecialSearchResult {
        if (searchType.isOnlyTorah()) {
            return SpecialSearchResult.Summary(
                message = searchType.getSummary().desc(),
                wasInterrupted = false,
                latestPlace = null,
            )
        }

        var latestPlace: StringDesc? = null
        var wasInterrupted = false

        for (chapter in searchedChapters) {
            if (!shouldKeepRunning()) {
                wasInterrupted = true
                break
            }

            val chapterDetails = getChapterVersesUseCase(
                filenameToLoad = chapter.filename,
                assetReader = assetReader,
            )

            searchType.process(chapterDetails)

            latestPlace = SharedRes.strings.search_progress_special_search_format.format(
                chapterDetails.bookName,
                chapterDetails.chapterName.addGershaim(),
            )

            onProgress(
                chapterDetails.bookName,
                chapterDetails.chapterName,
            )
        }

        return if (shouldShowAsList) {
            SpecialSearchResult.Items(
                results = mapSpecialSearchItemsToUiModelsUseCase(
                    items = searchType.provideItems(),
                ),
                wasInterrupted = wasInterrupted,
                latestPlace = latestPlace,
            )
        } else {
            SpecialSearchResult.Summary(
                message = searchType.getSummary().desc(),
                wasInterrupted = wasInterrupted,
                latestPlace = latestPlace,
            )
        }
    }
}
